import { Action, Reducer } from "redux";

import { MessageTemplateType } from "api/FlemingDtos";
import { TemplateInList } from "app/workspaceConversations/components/MessageTemplates/MessageTemplates.types";

import { SELECT_ORG } from "../account/AccountActions";
import {
    KnownAction,
    REQUEST_MESSAGE_TEMPLATES_FAILURE,
    REQUEST_MESSAGE_TEMPLATES_STARTED,
    REQUEST_MESSAGE_TEMPLATES_SUCCESS,
} from "./MessageTemplatesActions";

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface MessageTemplatesState {
    isMessageTemplatesLoading: boolean;
    lastGetMessageTemplatesFailed: boolean;
    smsTemplates: TemplateInList[];
    videoConsultTemplates: TemplateInList[];
    vcDefaultTemplate: TemplateInList | null;
}

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const initialState: MessageTemplatesState = {
    isMessageTemplatesLoading: false,
    lastGetMessageTemplatesFailed: false,
    smsTemplates: [],
    videoConsultTemplates: [],
    vcDefaultTemplate: null,
};

export const reducer: Reducer<MessageTemplatesState> = (
    state = initialState,
    incomingAction: Action,
): MessageTemplatesState => {
    const action = incomingAction as KnownAction;
    let smsTemplatesList: TemplateInList[];
    let vcTemplatesList: TemplateInList[];

    const shouldResetTemplates = [SELECT_ORG].includes(incomingAction.type);

    if (shouldResetTemplates) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_MESSAGE_TEMPLATES_STARTED:
            return {
                ...state,
                isMessageTemplatesLoading: true,
                lastGetMessageTemplatesFailed: false,
                smsTemplates: [],
                videoConsultTemplates: [],
                vcDefaultTemplate: null,
            };

        case REQUEST_MESSAGE_TEMPLATES_SUCCESS:
            vcTemplatesList = action.userTemplates.filter(
                ({ type }) => type === MessageTemplateType.VideoConsult,
            );
            smsTemplatesList = action.userTemplates.filter(
                ({ type }) => type === null || type === MessageTemplateType.Sms,
            );

            return {
                ...state,
                isMessageTemplatesLoading: false,
                lastGetMessageTemplatesFailed: false,
                smsTemplates: smsTemplatesList,
                videoConsultTemplates: vcTemplatesList,
                vcDefaultTemplate:
                    vcTemplatesList.find((t) => !!t.isDefault) || null,
            };

        case REQUEST_MESSAGE_TEMPLATES_FAILURE:
            return {
                ...state,
                isMessageTemplatesLoading: false,
                lastGetMessageTemplatesFailed: true,
                smsTemplates: [],
                videoConsultTemplates: [],
                vcDefaultTemplate: null,
            };

        default:
            return state;
    }
};
